module.exports = __webpack_public_path__ + "static/media/Logo_ISN.f797dcc8.svg";